import React, { useEffect } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import {
  ButtonGroup,
  Card,
  CardContent,
  CardHeader,
  Divider,
  FormControl,
  FormHelperText,
  Stack,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import MaterialTypography from "../../components/MaterialTypography";
import { BsFillPersonBadgeFill, BsFillPersonVcardFill } from "react-icons/bs";
import MaterialBox from "../../components/MaterialBox";
import MaterialSelect from "../../components/MasterSelect";
import MaterialInput from "../../components/MaterialInput";
import { FaPeopleGroup } from "react-icons/fa6";
import MaterialButton from "../../components/MaterialButton";
import { useState } from "react";
import request, { gql } from "graphql-request";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ConfirmationDialog from "../../components/Dialog/ConfirmationDialog";
import BASEURL from "../Utils/Baseurl";
import { useAuth } from "../../context/AuthContext/AuthContextProvider";
import { AddCutomerMutation } from "../../lib/graphQL/graphMutation";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { getCustomerDetail } from "../../lib/graphQL/graphQuery";
import {
  delteCustomerService,
  updateCustomerServive,
} from "../../lib/appUtliz/CustomerService";
import { useLoading } from "../../context/LodingContext";
import { useSuccess } from "../../context/SucccessContext";
import { useError } from "../../context/ErrorContext";
import { Country, State, City } from "country-state-city";

const GetGSTDetails = gql`
  query GetGSTDetails($gstinnumber: String!) {
    gstDetails(gstinNumber: $gstinnumber) {
      legalName
      tradeName
      pan
      registered
      customerCategory
      taxpayerType
    }
  }
`;


export default function AddCustomer() {
  // const [isFocused, setIsFocused] = useState(null);

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
    done: "",
    back: "",
  });

  const [selectedData, setSelectedData] = useState([]);

  const [customerData, setCustomerData] = useState({
    // customerdetails
    id: "",
    GSTNumber: "",
    legalName: "",
    tradeName: "",
    customerCategory: "",
    panNumber: "",
    taxPayerType: "",
    mailId: "",
    dateOfRegistration: "",
    addressLine1: "",
    addressLine2: "",
    country: "",
    state: "",
    city: "",
    zipCode: "",
    alternateAddressLine1: "",
    alternateAddressLine2: "",
    alternateCountry: "",
    alternateState: "",
    alternateCity: "",
    alternateZipCode: "",

    // customer status
    salutationStatus: "unchecked",
    GSTNumberStatus: "unchecked",
    legalNameStatus: "unchecked",
    tradeNameStatus: "unchecked",
    customerCategoryStatus: "unchecked",
    panNumberStatus: "unchecked",
    taxPayerTypeStatus: "unchecked",
    mailIdStatus: "unchecked",
    dateOfRegistrationStatus: "unchecked",
    addressLine1Status: "unchecked",
    addressLine2Status: "unchecked",
    countryStatus: "unchecked",
    stateStatus: "unchecked",
    cityStatus: "unchecked",
    zipCodeStatus: "unchecked",
    alternateAddressLine1Status: "unchecked",
    alternateAddressLine2Status: "unchecked",
    alternateCountryStatus: "unchecked",
    alternateStateStatus: "unchecked",
    alternateCityStatus: "unchecked",
    alternateZipCodeStatus: "unchecked",
  });
  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });


  useEffect(() => {
  }, [customerData]);


  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const params = useLocation();
  const id = params.search.slice(1);
  const { circleLoading, setCirleLoading } = useLoading();
  const { successStatus, setSuccessStatus, setSucessTitle } = useSuccess();
  const { errorStatus, setErrorStatus, errormessage, setErrormessage } = useError();

  useEffect(() => {
    if (id) {
      fetchUpdateValue();
    }
  }, [id]);
  const fetchUpdateValue = async () => {
    try {
      const res = await request(BASEURL, getCustomerDetail, {
        id: id,
      });
      const v = res.getCustomerDetail;
      // res.filter((v, i) => {

      setSelectedData(v);
      setCustomerData({
        GSTNumber: v.GSTNumber,
        legalName: v.legalName,
        tradeName: v.tradeName,
        customerCategory: v.customerCategory,
        panNumber: v.pan,
        taxPayerType: v.taxpayerType,
        mailId: v.mailId,
        dateOfRegistration: v.dateOfRegistration,
        addressLine1: v.address1Line1,
        addressLine2: v.address1Line2,
        country: {
          value: v.country1,
          label: v.country1,
          isoCode: Country.getAllCountries().find((c) => c.name === v.country1)?.isoCode,
        },
        state: {
          value: v.state1,
          label: v.state1,
          isoCode: State.getStatesOfCountry(
            Country.getAllCountries().find((c) => c.name === v.country1)?.isoCode
          ).find((s) => s.name === v.state1)?.isoCode,
        },
        city: {
          value: v.city1,
          label: v.city1,
        },
        zipCode: v.zipCode1,
        alternateAddressLine1: v.address2Line1,
        alternateAddressLine2: v.address2Line2,
        alternateCountry: v.country2
        ? {
            value: v.country2,
            label: v.country2,
            isoCode: Country.getAllCountries().find((c) => c.name === v.country2)?.isoCode,
          }
        : null,
        alternateState: v.state2
        ? {
            value: v.state2,
            label: v.state2,
            isoCode: State.getStatesOfCountry(
              Country.getAllCountries().find((c) => c.name === v.country2)?.isoCode
            ).find((s) => s.name === v.state2)?.isoCode,
          }
        : null,
        alternateCity: v.city2
        ? {
            value: v.city2,
            label: v.city2,
          }
        : null,
        alternateZipCode: v.zipCode2 || "",

        // customer status
        salutationStatus: "success",
        GSTNumberStatus: "success",
        legalNameStatus: "success",
        tradeNameStatus: "success",
        customerCategoryStatus: "success",
        panNumberStatus: "success",
        taxPayerTypeStatus: "success",
        mailIdStatus: "success",
        dateOfRegistrationStatus: "success",
        addressLine1Status: "success",
        addressLine2Status: "success",
        countryStatus: "success",
        stateStatus: "success",
        cityStatus: "success",
        zipCodeStatus: "success",
        alternateAddressLine1Status: "success",
        alternateAddressLine2Status: "success",
        alternateCountryStatus: "success",
        alternateStateStatus: "success",
        alternateCityStatus: "success",
        alternateZipCodeStatus: "success",
      });
      
      // });
    } catch (err) {
      console.error(err.message);
    }
  };

  useEffect(() => {
    
    const isGSTValid = /^[A-Z0-9]{15}$/.test(customerData.GSTNumber);
  
    if (!isGSTValid) {
      setCustomerData((prevState) => ({
        ...prevState,
        legalName: "",
        tradeName: "",
        panNumber: "",
        customerCategory: "",
        taxPayerType: "",
        dateOfRegistration: "",
        legalNameStatus: "unchecked",
        tradeNameStatus: "unchecked",
        panNumberStatus: "unchecked",
        customerCategoryStatus: "unchecked",
        taxPayerTypeStatus: "unchecked",
        dateOfRegistrationStatus: "unchecked",
      }));
    }
  }, [customerData.GSTNumber]);
  
  useEffect(() => {
    setTogglePage({
      ...togglePage,
      view: params?.search !== "" ? true : false,
    });
  }, []);

  const handleDiscardButton = () => {
    setTogglePage({
      view: true,
      edit: false,
    });
    setCustomerData({
      GSTNumber: selectedData?.GSTNumber,
      legalName: selectedData?.legalName,
      tradeName: selectedData?.tradeName,
      customerCategory: selectedData?.customerCategory,
      panNumber: selectedData.pan,
      taxPayerType: selectedData.taxpayerType,
      mailId: selectedData.mailId,
      dateOfRegistration: selectedData.registered,
      addressLine1: selectedData.address1Line1,
      addressLine2: selectedData.address1Line2,
      country: {value:selectedData.country1,label:selectedData.country1},
      state: {value:selectedData.state1,label:selectedData.state1},
      city: {value:selectedData.city1,label:selectedData.city1},
      zipCode: selectedData.zipCode1,
      alternateAddressLine1: selectedData.address2Line2,
      alternateAddressLine2: selectedData.address2Line2,
      alternateCountry: {value:selectedData.country2,label:selectedData.country2},
      alternateState: {value:selectedData.state2,label:selectedData.state2},
      alternateCity: {value:selectedData.city2, label:selectedData.city2},
      alternateZipCode: selectedData.zipCode2,

      salutationStatus: "success",
      GSTNumberStatus: "success",
      legalNameStatus: "success",
      tradeNameStatus: "success",
      customerCategoryStatus: "success",
      panNumberStatus: "success",
      taxPayerTypeStatus: "success",
      mailIdStatus: "success",
      dateOfRegistrationStatus: "success",
      addressLine1Status: "success",
      addressLine2Status: "success",
      countryStatus: "success",
      stateStatus: "success",
      cityStatus: "success",
      zipCodeStatus: "success",
      alternateAddressLine1Status: "success",
      alternateAddressLine2Status: "success",
      alternateCountryStatus: "success",
      alternateStateStatus: "success",
      alternateCityStatus: "success",
      alternateZipCodeStatus: "success",
    });
  };

  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
  };



  const handleCustomerData = async (event, selectEvent) => {
    let customerState = { ...customerData };

    // if (event?.target === undefined && selectEvent) {
    //   if (selectEvent.name === "country") {

    //     const lengthRegex = new RegExp("^[A-Za-z0-9]");
    //     if (lengthRegex.test(event?.label) === true) {
    //       customerState[selectEvent.name + "Status"] =
    //         event?.label === undefined ? "unchecked" : "success";
    //     } else {
    //       customerState[selectEvent.name + "Status"] =
    //         selectEvent.value === "" ? "unchecked" : "error";
    //     }
    //   } 
    //   else if (selectEvent.name === "state") {
    //     const lengthRegex = new RegExp("^[A-Za-z0-9]");
    //     if (lengthRegex.test(event?.label) === true) {
    //       customerState[selectEvent.name + "Status"] =
    //         event?.label === undefined ? "unchecked" : "success";
    //     } else {
    //       customerState[selectEvent.name + "Status"] =
    //         selectEvent.value === "" ? "unchecked" : "error";
    //     }
    //   } 
    //   else if (selectEvent.name === "city") {
    //     const lengthRegex = new RegExp("^[A-Za-z0-9]");
    //     if (lengthRegex.test(event?.label) === true) {
    //       customerState[selectEvent.name + "Status"] =
    //         event?.label === undefined ? "unchecked" : "success";
    //     } else {
    //       customerState[selectEvent.name + "Status"] =
    //         selectEvent.value === "" ? "unchecked" : "error";
    //     }
    //   }
    //   customerState[selectEvent.name] = event;

    // }
    // else if (event?.target === undefined && selectEvent) {
    //   if (selectEvent.name === "alternateCountry") {
    //     // Reset alternate state and city when alternate country changes
    //     customerState = {
    //       ...customerState,
    //       alternateCountry: event,
    //       alternateState: null,
    //       alternateCity: null,
    //       alternateStateStatus: "unchecked",
    //       alternateCityStatus: "unchecked",
    //     };
    //   } else if (selectEvent.name === "alternateState") {
    //     // Reset alternate city when alternate state changes
    //     customerState = {
    //       ...customerState,
    //       alternateState: event,
    //       alternateCity: null,
    //       alternateCityStatus: "unchecked",
    //     };
    //   }
    //    else if (selectEvent.name === "alternateCity") {
    //     const lengthRegex = new RegExp("^[A-Za-z0-9]");
    //     if (lengthRegex.test(event?.label) === true) {
    //       customerState[selectEvent.name + "Status"] =
    //         event?.label === undefined ? "unchecked" : "success";
    //     } else {
    //       customerState[selectEvent.name + "Status"] =
    //         selectEvent.value === "" ? "unchecked" : "error";
    //     }
    //   }
    //   customerState[selectEvent.name] = event;
    // }

    if (event?.target === undefined && selectEvent) {
      if (selectEvent.name === "country") {
        customerState = {
          ...customerState,
          country: event,
          state: null,
          city: null,
          stateStatus: "unchecked",
          cityStatus: "unchecked",
          countryStatus: "success", 
        };
      } 
      else if (selectEvent.name === "state") {
        customerState = {
           ...customerState,
          state: event,
          city: null,
          cityStatus: "unchecked",
          stateStatus: "success", 
        };
      } else if (selectEvent.name === "alternateCountry") {
        customerState = {
          ...customerState,
          alternateCountry: event,
          alternateState: null,
          alternateCity: null,
          alternateStateStatus: "unchecked",
          alternateCityStatus: "unchecked",
          alternateCountryStatus: "success", 
        };
      } else if (selectEvent.name === "alternateState") {
        customerState = {
          ...customerState,
          alternateState: event,
          alternateCity: null,
          alternateCityStatus: "unchecked",
          alternateStateStatus: "success",
        };
      } else {
        // Default: city, alternateCity
        customerState[selectEvent.name] = event;
        if (selectEvent.name) {
          customerState[`${selectEvent.name}Status`] = "success";
        }
      }
    
      setCustomerData(customerState);
    }
    
    else {
      switch (event.target.name) {
        case "GSTNumber": {
          // const alphaNLenghthRegex = new RegExp("^([A-Z0-9]{15,16})$");
          const alphaNLenghthRegex = new RegExp("^([A-Z0-9]{15})$");
          const gstValue = event.target.value.trim();
        
        if (alphaNLenghthRegex.test(gstValue))
        {
          // customerState[event.target.name] = event.target.value
          customerState[event.target.name + "Status"] = "success"
        }
        else{
          customerState[event.target.name + "Status"] =
          event.target.value === "" ? "unchecked" : "error";
        }
          setCustomerData((prevState) => ({
            ...prevState,
            GSTNumber: gstValue,
            GSTNumberStatus: alphaNLenghthRegex.test(gstValue) ? "success" : gstValue === "" ? "unchecked" : "error",
          }));

 
          if (alphaNLenghthRegex.test(gstValue)) {


            try {
              const response = await request(BASEURL, GetGSTDetails, {
                gstinnumber: gstValue,
              });

              const gstDetails = response.gstDetails;
              customerState["legalName"] = gstDetails.legalName || ""
              customerState["tradeName"] = gstDetails.tradeName || ""
              customerState["panNumber"] = gstDetails.pan || ""
              customerState["customerCategory"] = gstDetails.customerCategory || ""
              customerState["taxPayerType"] = gstDetails.taxpayerType || ""
              customerState["dateOfRegistration"] = gstDetails.registered || ""
              customerState["legalNameStatus"] = gstDetails.legalName ? "success" : "unchecked"
              customerState["tradeNameStatus"] = gstDetails.tradeName ? "success" : "unchecked"
              customerState["panNumberStatus"] = gstDetails.pan ? "success" : "unchecked"
              customerState["dateOfRegistrationStatus"] = gstDetails.registered ? "success" : "unchecked"
              customerState["customerCategoryStatus"] = gstDetails.customerCategory
                ? "success"
                : "unchecked"
              customerState["taxPayerTypeStatus"] = gstDetails.taxpayerType
                ? "success"
                : "unchecked"

         
            } catch (error) {
              console.error("Failed to fetch GST details:", error);
            }
          }
          break;
        }

        case "legalName":
          {
            const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{2,80})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              customerState[event.target.name + "Status"] = "success";
            } else {
              customerState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "tradeName":
          {
            const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{1,80})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              customerState[event.target.name + "Status"] = "success";
            } else {
              customerState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "customerCategory":
          {
            const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{1,60})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              customerState[event.target.name + "Status"] = "success";
            } else {
              customerState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "panNumber":
          {
            const alphaNLenghthRegex = new RegExp("^([A-Z0-9]{10})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              customerState[event.target.name + "Status"] = "success";
            } else {
              customerState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "taxPayerType":
          {
            const alphaNLenghthRegex = new RegExp("^([A-Za-z]{1,20})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              customerState[event.target.name + "Status"] = "success";
            } else {
              customerState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "mailId":
          {
            const alphaNLenghthRegex = new RegExp(
              /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g
            );
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              customerState[event.target.name + "Status"] = "success";
            } else {
              customerState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
          case "dateOfRegistration": {
            const alphaNLenghthRegex = /^\d{2}-\d{2}-\d{4}$/;
            const dateValue = event.target.value?.trim();
          
            if (alphaNLenghthRegex.test(dateValue)) {
              const [day, month, year] = dateValue.split("-").map(Number);
              const date = new Date(year, month - 1, day);
          
              if (date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day) {
                customerState[event.target.name + "Status"] = "success";
              } else {
                customerState[event.target.name + "Status"] = "error"; 
              }
            } else {
              customerState[event.target.name + "Status"] =
                dateValue === "" ? "unchecked" : "error";
            }
            break;
          }
          
        case "addressLine1":
          {
            const alphaNLenghthRegex = new RegExp("^[\\s\\S]{5,150}$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              customerState[event.target.name + "Status"] = "success";
            } else {
              customerState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "addressLine2":
          {
            const alphaNLenghthRegex = new RegExp("^[\\s\\S]{5,150}$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              customerState[event.target.name + "Status"] = "success";
            } else {
              customerState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "zipCode":
          {
            const alphaNLenghthRegex = new RegExp("^([a-zA-z0-9]{6})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              customerState[event.target.name + "Status"] = "success";
            } else {
              customerState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "alternateAddressLine1":
          {
            const alphaNLenghthRegex = new RegExp("^[\\s\\S]{5,150}$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              customerState[event.target.name + "Status"] = "success";
            } else {
              customerState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "alternateAddressLine2":
          {
            const alphaNLenghthRegex = new RegExp("^[\\s\\S]{5,150}$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              customerState[event.target.name + "Status"] = "success";
            } else {
              customerState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "alternateZipCode":
          {
            const alphaNLenghthRegex = new RegExp("^([a-zA-z0-9]{6})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              customerState[event.target.name + "Status"] = "success";
            } else {
              customerState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
      }
      customerState[event.target.name] = event.target.value;
    }
    setCustomerData(customerState);
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      (customerData.GSTNumberStatus === "success" ||
        customerData.GSTNumberStatus === "unchecked") &&
      customerData.legalNameStatus === "success" &&
      (customerData.tradeNameStatus === "success" ||
        customerData.tradeNameStatus === "unchecked") &&
      customerData.customerCategoryStatus === "success" &&
      (customerData.panNumberStatus === "success" ||
        customerData.panNumberStatus === "unchecked") &&
      customerData.taxPayerTypeStatus === "success" &&
      customerData.mailIdStatus === "success" &&
      (customerData.dateOfRegistrationStatus === "success" ||
        customerData.dateOfRegistrationStatus === "unchecked") &&
      customerData.addressLine1Status === "success" &&
      customerData.countryStatus === "success" &&
      customerData.stateStatus === "success" &&
      customerData.cityStatus === "success" &&
      customerData.zipCodeStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const handleAddCustomerData = async () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to submit your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: async () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        setCirleLoading(true);
        try {
          const response = await request(BASEURL, AddCutomerMutation, {
            id: currentUser?.id,
            GSTNumber: customerData.GSTNumber,
            legalName: customerData.legalName,
            tradeName: customerData.tradeName,
            customerCategory: customerData.customerCategory,
            pan: customerData.panNumber,
            taxPayerType: customerData.taxPayerType,
            dateOfRegistration: customerData.dateOfRegistration || "",
            mail: customerData.mailId,
            address1Line1: customerData.addressLine1,
            address1Line2: customerData.addressLine2,
            country1: customerData.country?.value || "",
            state1: customerData.state?.value || "",
            city1: customerData.city?.value || "",
            zipCode1: customerData.zipCode,
            address2Line1: customerData.alternateAddressLine1,
            address2Line2: customerData.alternateAddressLine2,
            state2: customerData.alternateState?.value || "",
            city2: customerData.alternateCity?.value || "",
            country2: customerData.alternateCountry?.value || "",
            zipCode2: customerData.alternateZipCode,
          });
          setSuccessStatus(true);
          setSucessTitle("Customer Created");
          setTimeout(() => {
            setSuccessStatus(false);
            navigate("/customer-360");
          }, 1000);
        } catch (error) {
          setErrorStatus(true);
          setErrormessage(error?.response?.errors[0]?.message);
          setTimeout(() => {
            setErrorStatus(false);
          }, 3000);
        } finally {
          setCirleLoading(false);
        }
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const handleEditCustomerData = async () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Edit your details.",
      showCancel: true,
      showConfirm: true,

      onConfirm: async () => {
        const values = {
          // user: currentUser?.id,
          GSTNumber: customerData.GSTNumber,
          legalName: customerData.legalName,
          tradeName: customerData.tradeName,
          customerCategory: customerData.customerCategory,
          pan: customerData.panNumber,
          taxPayerType: customerData.taxPayerType,
          dateOfRegistration: customerData.dateOfRegistration,
          mail: customerData.mailId,
          address1Line1: customerData.addressLine1,
          address1Line2: customerData.addressLine2,
          country1: customerData.country?.value || "",
          state1: customerData.state?.value || "",
          city1: customerData.city?.value || "",
          zipCode1: customerData.zipCode,
          address2Line1: customerData.alternateAddressLine1,
          address2Line2: customerData.alternateAddressLine2,
          state2: customerData.alternateState?.value || "",
          city2: customerData.alternateCity?.value || "",
          country2: customerData.alternateCountry?.value || "",
          zipCode2: customerData.alternateZipCode,
        };
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        setCirleLoading(true);
        const{updateStatus,errormessage} = await updateCustomerServive(values, id);
        setCirleLoading(false);
        if (updateStatus) {
          setSuccessStatus(true);
          setSucessTitle("Customer Updated");
          setTimeout(() => {
            setSuccessStatus(false);
            navigate("/customer-360");
          }, 1000);
        } else {
          setErrorStatus(true);
          setErrormessage(errormessage)
          setTimeout(() => {
            setErrorStatus(false);
          }, 1000);
        }
        // updateStatus ? navigate("/customer-management") : alert("no edit");
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };
  const handleDelteCustomerData = async () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Delete your detail.",
      showCancel: true,
      showConfirm: true,

      onConfirm: async () => {
        setCirleLoading(true);
        const delteStatus = await delteCustomerService(id);
        setCirleLoading(false);
        if (delteStatus) {
          setSuccessStatus(true);
          setSucessTitle("Customer Deleted");
          setTimeout(() => {
            setSuccessStatus(false);
            navigate("/customer-360");
          }, 1000);
        } else {
          setErrorStatus(true);
          setTimeout(() => {
            setErrorStatus(false);
          }, 1000);
        }
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };
  const handleCancelCustomerData = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message:
        "The Entered Details will not be saved. Do you want to Cancel it?",
      showCancel: true,
      showConfirm: true,
      onConfirm: async () => {
        // const delteStatus = await deleteBrandService(id);
        // if (delteStatus) {
        navigate("/customer-360");
        // } else if (!delteStatus) {
        // }
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };
  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
          done={confirmationDialog.done}
          back={confirmationDialog.back}
        />
      )}
      <Card>
        <CardHeader
          title={
            <>
              {togglePage.view === true  ? (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h6" fontWeight="medium">
                      Customer Details
                    </MaterialTypography>
                  </Stack>
                  <ButtonGroup
                    variant="outlined"
                    aria-label="Loading button group"
                    size="small"
                  >
                    <MaterialButton
                      variant="gradient"
                      color="dark"
                      onClick={toggleEdit}
                      startIcon={<EditIcon />}
                    >
                      Edit
                    </MaterialButton>
                    <MaterialButton
                      variant="gradient"
                      color="dark"
                      onClick={handleDelteCustomerData}
                      startIcon={<DeleteIcon />}
                    >
                      delete
                    </MaterialButton>
                  </ButtonGroup>
                </Stack>
              ):togglePage.edit === true? (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h6" fontWeight="medium">
                      Edit Customer Details
                    </MaterialTypography>

                  </Stack>
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    onClick={toggleEdit}
                    startIcon={<EditIcon />}
                  >
                    Edit
                  </MaterialButton>
                </Stack>
              )
                : (
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={2}
                  >
                    <Stack direction="column" spacing={0}>
                      <MaterialTypography variant="h6" fontWeight="medium">
                        Add Customer Details
                      </MaterialTypography>
                    </Stack>
                  </Stack>
                )}
            </>
          }
        />
        <CardContent sx={{ minHeight: "70vh" }}>
         <Stack direction="row" spacing={1} p={1} bgcolor={"#f5f5f5"}>
                                 <BsFillPersonBadgeFill style={{ fontSize: 20, color:'#460058' }} />
                                 <MaterialTypography
                                 sx={{color:'#460058',fontFamily:'Aptos'}}
                                   component="label"
                                   variant="body2"
                                   fontWeight="700"
                                 >
                                   Customer Information
                                 </MaterialTypography>
                               </Stack>
          <MaterialBox>
            <Grid container spacing={2}>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                    
                  >
                    GST Number
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="GSTNumber"
                  size="small"
                  placeholder="Enter GST Number"
                  value={customerData.GSTNumber}
                  inputProps={{ maxLength: 15 }}
                  onChange={handleCustomerData}
                  error={
                    customerData.GSTNumberStatus === "error" ? true : false
                  }
                  success={
                    customerData.GSTNumberStatus === "success" ? true : false
                  }
                  disabled={togglePage.view === true || togglePage.edit}
                />
                {customerData.GSTNumberStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      GST Number should be maximum 15 characters along with
                      state code
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Customer Legal Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="legalName"
                  placeholder=" Enter Legal Name  "
                  value={customerData.legalName}
                  onChange={handleCustomerData}
                  error={
                    customerData.legalNameStatus === "error" ? true : false
                  }
                  success={
                    customerData.legalNameStatus === "success" ? true : false
                  }
                  disabled={togglePage.view === true || togglePage.edit}
                />
                {customerData.legalNameStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Legal Name should be min 2 max 25 characters long and can
                      contain only alphabets
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Trade Name
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="tradeName"
                  size="small"
                  placeholder="Enter Trade Name "
                  value={customerData.tradeName}
                  onChange={handleCustomerData}
                  error={
                    customerData.tradeNameStatus === "error" ? true : false
                  }
                  success={
                    customerData.tradeNameStatus === "success" ? true : false
                  }
                  disabled={togglePage.view === true || togglePage.edit}
                />
                {customerData.tradeNameStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      trade Name should be maximum 20 characters long
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Customer Category <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="customerCategory"
                  size="small"
                  placeholder="Customer Category"
                  value={customerData.customerCategory}
                  onChange={handleCustomerData}
                  error={
                    customerData.customerCategoryStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    customerData.customerCategoryStatus === "success"
                      ? true
                      : false
                  }
                  disabled={togglePage.view === true || togglePage.edit}
                />
                {customerData.customerCategoryStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Customer Category should be maximum 20 characters long
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    PAN Number
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="panNumber"
                  size="small"
                  placeholder="Enter Pan Number "
                  value={customerData.panNumber}
                  onChange={handleCustomerData}
                  error={
                    customerData.panNumberStatus === "error" ? true : false
                  }
                  success={
                    customerData.panNumberStatus === "success" ? true : false
                  }
                  disabled={togglePage.view === true || togglePage.edit}
                />
                {customerData.panNumberStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      PAN Number should be maximum 10 characters long
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    TAX Payer Type <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="taxPayerType"
                  size="small"
                  placeholder="Enter Tax Pay"
                  value={customerData.taxPayerType}
                  onChange={handleCustomerData}
                  error={
                    customerData.taxPayerTypeStatus === "error" ? true : false
                  }
                  success={
                    customerData.taxPayerTypeStatus === "success" ? true : false
                  }
                  disabled={togglePage.view === true || togglePage.edit}
                />
                {customerData.taxPayerTypeStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Tax Payer Type should be maximum 20 characters long
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    MailID <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="mailId"
                  size="small"
                  placeholder="Enter mailid"
                  value={customerData.mailId}
                  onChange={handleCustomerData}
                  error={customerData.mailIdStatus === "error" ? true : false}
                  success={
                    customerData.mailIdStatus === "success" ? true : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {customerData.mailIdStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Please Enter a Valid Email Address
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Date Of Registration
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="dateOfRegistration"
                  size="small"
                  // type="date"
                  placeholder="eg. 01-01-2024"
                  value={customerData.dateOfRegistration}
                  // defaultValue={{
                  //   label: customerData.dateOfRegistration?.label
                  // }}
                  onChange={handleCustomerData}
                  isDisabled={togglePage?.view === true ? true : false}
                  error={
                    customerData.dateOfRegistrationStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    customerData.dateOfRegistrationStatus === "success"
                      ? true
                      : false
                  }
                  disabled={togglePage.view === true || togglePage.edit}
                />
                {customerData.dateOfRegistrationStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Please Enter a Valid Date Of Registration
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
            </Grid>
          </MaterialBox>
          <Divider />
          <Stack direction="row" spacing={1} p={1} bgcolor={"#f5f5f5"}>
              <BsFillPersonBadgeFill style={{ fontSize: 20, color:'#460058' }} />
              <MaterialTypography
              sx={{color:'#460058',fontFamily:'Aptos'}}
                component="label"
                variant="body2"
                fontWeight="700"
              >
                Customer Address
              </MaterialTypography>
            </Stack>
          <MaterialBox>
            <Grid container spacing={2}>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Address Line 1 <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="addressLine1"
                  size="small"
                  placeholder="eg. Door No., Street"
                  value={customerData.addressLine1}
                  onChange={handleCustomerData}
                  error={
                    customerData.addressLine1Status === "error" ? true : false
                  }
                  success={
                    customerData.addressLine1Status === "success" ? true : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                  multiline
                  rows={4.5}
                />
                {customerData.addressLine1Status === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Please Enter a Valid Address
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Country <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="country"
                  placeholder="eg. India"
                  size="small"
                  isDisabled={togglePage?.view === true ? true : false}
                  value={customerData.country}
                  defaultValue={{
                    label: customerData.country?. label
                  }}
                  onChange={handleCustomerData}
                  options={Country.getAllCountries().map((value) => {
                    return {
                      value: value.name,
                      label: value.name,
                      isoCode: value.isoCode
                    };
                  })}
                  error={customerData.countryStatus === "error" ? true : false}
                  success={
                    customerData.countryStatus === "success" ? true : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {customerData.countryStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>Please Enter your Country</FormHelperText>
                  </FormControl>
                )}
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Zip Code <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="zipCode"
                  size="small"
                  placeholder="eg. 560038"
                  value={customerData.zipCode}
                  onChange={handleCustomerData}
                  error={customerData.zipCodeStatus === "error" ? true : false}
                  success={
                    customerData.zipCodeStatus === "success" ? true : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {customerData.zipCodeStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Please Enter Zipcode with maximum 6 numbers
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    State <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="state"
                  size="small"
                  placeholder="eg. Karnataka"
                  value={customerData.state}
                  isDisabled={togglePage?.view === true ? true : false}
                  defaultValue={{
                    label: customerData.state?. label
                  }}
                  onChange={handleCustomerData}
                  options={State.getStatesOfCountry(customerData.country?.isoCode || "").map((value) => {
                    return {
                      value: value.name,
                      label: value.name,
                      isoCode: value.isoCode,
                      countryCode: value.countryCode
                    };
                  })}

                  error={customerData.stateStatus === "error" ? true : false}
                  success={
                    customerData.stateStatus === "success" ? true : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {customerData.stateStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>Please Enter Your State</FormHelperText>
                  </FormControl>
                )}
                
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    City <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="city"
                  size="small"
                  placeholder="eg. Bangalore"
                  isDisabled={togglePage?.view === true ? true : false}
                  value={customerData.city}
                  defaultValue={{
                    label: customerData.city?. label
                  }}
                  onChange={handleCustomerData}
                  options={City.getCitiesOfState(customerData.state?.countryCode || "", customerData.state?.isoCode || "").map((value) => {
                    return {
                      value: value.name,
                      label: value.name,
                      isoCode: value.isoCode,
                      countryCode: value.isoCode
                    };
                  })}
                  error={customerData.cityStatus === "error" ? true : false}
                  success={customerData.cityStatus === "success" ? true : false}
                  disabled={togglePage?.view === true ? true : false}
                />
                {customerData.cityStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>Please Enter Your City</FormHelperText>
                  </FormControl>
                )}
                
              </Grid>
              
            </Grid>
          </MaterialBox>
          <Divider />
          <Stack direction="row" spacing={1} p={1} bgcolor={"#f5f5f5"}>
              <BsFillPersonBadgeFill style={{ fontSize: 20, color:'#460058' }} />
              <MaterialTypography
              sx={{color:'#460058',fontFamily:'Aptos'}}
                component="label"
                variant="body2"
                fontWeight="700"
              >
                Customer Alternate Address
              </MaterialTypography>
            </Stack>
          <MaterialBox>
            <Grid container spacing={2}>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Alternate Address Line 1
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="alternateAddressLine1"
                  size="small"
                  placeholder="eg. Door No., Street"
                  value={customerData.alternateAddressLine1}
                  onChange={handleCustomerData}
                  error={
                    customerData.alternateAddressLine1Status === "error"
                      ? true
                      : false
                  }
                  success={
                    customerData.alternateAddressLine1Status === "success"
                      ? true
                      : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                  multiline
                  rows={4.5}
                
                />
                {customerData.alternateAddressLine1Status === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Please Enter Your Valid Address
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Alternate Country
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="alternateCountry"
                  size="small"
                  placeholder="eg. India"
                  value={customerData.alternateCountry}
                  isDisabled={togglePage?.view === true ? true : false}
                  onChange={handleCustomerData}
                  defaultValue={{
                    label: customerData.alternateCountry?. label
                  }}
                  options={Country.getAllCountries().map((value) => {
                    return {
                      value: value.name,
                      label: value.name,
                      isoCode: value.isoCode
                    };
                  })}
                  error={
                    customerData.alternateCountryStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    customerData.alternateCountryStatus === "success"
                      ? true
                      : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {customerData.alternateCountryStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Please Enter Your Alternate Country
                    </FormHelperText>
                  </FormControl>
                )}
                 <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Alternate Zip Code
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="alternateZipCode"
                  size="small"
                  placeholder="eg. 600126"
                  value={customerData.alternateZipCode}
                  onChange={handleCustomerData}
                  error={
                    customerData.alternateZipCodeStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    customerData.alternateZipCodeStatus === "success"
                      ? true
                      : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {customerData.alternateZipCodeStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Please Enter Zipcode with maximum 6 numbers
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Alternate State
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="alternateState"
                  size="small"
                  placeholder= "eg. Tamil Nadu"
                  value={customerData.alternateState}
                  isDisabled={togglePage?.view === true ? true : false}
                  onChange={handleCustomerData}
                  options={State.getStatesOfCountry(customerData.alternateCountry?.isoCode).map((value) => {
                    return {
                      value: value.name,
                      label: value.name,
                      isoCode: value.isoCode,
                      countryCode: value.countryCode
                    };
                  })}
                  error={
                    customerData.alternateStateStatus === "error" ? true : false
                  }
                  success={
                    customerData.alternateStateStatus === "success"
                      ? true
                      : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {customerData.alternateStateStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Please Enter Your Alternate State
                    </FormHelperText>
                  </FormControl>
                )}
                
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Alternate City
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="alternateCity"
                  size="small"
                  placeholder="eg. Chennai"
                  isDisabled={togglePage?.view === true ? true : false}
                  value={customerData.alternateCity}
                  onChange={handleCustomerData}
                  options={City.getCitiesOfState(customerData.alternateState?.countryCode || "", customerData.alternateState?.isoCode).map((value) => {
                    return {
                      value: value.name,
                      label: value.name,
                      isoCode: value.isoCode,
                      countryCode: value.isoCode
                    };
                  })}
                  error={
                    customerData.alternateCityStatus === "error" ? true : false
                  }
                  success={
                    customerData.alternateCityStatus === "success"
                      ? true
                      : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {customerData.alternateCityStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>Please Enter Your City</FormHelperText>
                  </FormControl>
                )}
                
               
              </Grid>
             
            </Grid>
          </MaterialBox>
         
        </CardContent>
         <MaterialBox
            display="flex"
          justifyContent="center"
          alignItems="center"
          sx={{ mb: 4.5, mr: 5 }}
          >
            {togglePage.edit === true ? (
              <>
 
                    <MaterialButton
                      variant="gradient"
                      color="dark"
                      size="small"
                      onClick={handleDiscardButton}
                    >
                      Discard
                    </MaterialButton>
                    <MaterialButton
                      sx={{ m: 2 }}
                      variant="gradient"
                      color="dark"
                      size="small"
                      disabled={!checkAllFields()}
                      onClick={handleEditCustomerData}
                    >
                      Submit
                    </MaterialButton>

              </>
            ) : togglePage.view === false && togglePage.edit === false ? (
              <>
                <Stack spacing={2} direction='row'>
                <MaterialBox p={2} display="flex" gap={2}>
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    onClick={handleCancelCustomerData}
                  >
                    Cancel
                  </MaterialButton>
                    <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"

                    disabled={!checkAllFields()}
                    onClick={handleAddCustomerData}
                  >
                    Submit
                  </MaterialButton>
                </MaterialBox>
                </Stack>
              </>
            ) : null}
          </MaterialBox>
      </Card>
    </DashboardLayout>
  );
}
